import Link from 'next/link';
import useGetUser from '../../../hooks/useGetUser';
import { UserImage } from '../../userImage';

export const TeamCard = ({ id, name, title, description, walletAddress }) => {
  const member = useGetUser(walletAddress).data;
  return (
    <div className='rounded-2.5xl h-[250px] w-[150px] border border-jacarta-100 bg-white dark:border-jacarta-700 dark:bg-jacarta-700 md:h-[282px] md:w-[180px]'>
      <div className='flex flex-col items-center justify-center space-y-2 p-2'>
        <div className='mt-5 flex h-10 w-10 items-center justify-center rounded-full '>
          <Link href={`/user/${walletAddress}`}>
            <a target='_blank' rel='noopener noreferrer'>
              {<UserImage user={member || { walletAddress: walletAddress }} />}
            </a>
          </Link>
        </div>
        <div className='justify-self-center text-center text-sm font-bold md:text-base'>{name}</div>
        <div className='text-center text-sm text-accent md:text-base'>{title}</div>
        <div className='break-all text-center text-xs md:text-sm'>{description}</div>
      </div>
    </div>
  );
};
